import React, {useEffect, useRef, useState} from 'react';
import {SaveButton, Title, translate} from "react-admin";
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    LinearProgress,
    List,
    ListItem,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField
} from '@material-ui/core';
import axiosInstance from "../../api/axios";
import moment from "moment";
import {CancelButton, showErrorNotify} from "../../components";


const Filter = translate(({translate, filterParams = {}, onChangeFilter}) => {
    return <Grid container spacing={24} alignItems={'flex-end'}>
        <Grid item>
            <TextField type={'date'}
                       label={translate("resources.unit-discipline.fields.checkDate")}
                       value={filterParams['checkDate']}
                       onChange={e => onChangeFilter('checkDate', e.target.value)}
                       inputProps={{max: moment().format('YYYY-MM-DD')}}
            />
        </Grid>
    </Grid>
})

const UpdateUnitDisciplineDialog = translate(({open, onClose, onSave, saving, data = {}}) => {
    const ref = useRef([...data.disciplineCategories])

    const onChangeValue = (field, index) => (event) => {
        ref.current[index][field] = event.target.value
    }

    return <React.Fragment>
        <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth disableBackdropClick disableEscapeKeyDown>
            <DialogTitle>
                {data.unitId} - {data.unitName}
            </DialogTitle>
            <DialogContent style={{padding: 0}}>
                <List component="nav">
                    {
                        data.disciplineCategories.map((item, idx) => <ListItem key={item.id}>
                            <Grid container spacing={24}>
                                <Grid item xs={'auto'}>
                                    <TextField disabled
                                               label={'Nội dung'}
                                               InputLabelProps={{shrink: true}}
                                               defaultValue={item.name}
                                               style={{width: 300}}
                                    />
                                </Grid>
                                <Grid item xs='auto'>
                                    <TextField label='Số lượt'
                                               type='number'
                                               inputProps={{min: 0}}
                                               style={{width: 80}}
                                               InputLabelProps={{shrink: true}}
                                               defaultValue={item.count}
                                               onChange={onChangeValue('count', idx)}
                                    />
                                </Grid>

                                <Grid item xs>
                                    <TextField fullWidth
                                               label='Ghi chú'
                                               InputLabelProps={{shrink: true}}
                                               defaultValue={item.note}
                                               onChange={onChangeValue('note', idx)}
                                    />
                                </Grid>
                            </Grid>
                        </ListItem>)
                    }
                </List>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={onClose}/>
                <SaveButton saving={saving} disabled={saving} onClick={() => onSave(data.unitId, ref.current)}/>
            </DialogActions>
        </Dialog>

    </React.Fragment>
})

const DataTable = translate(({translate, filterParams = {}, history}) => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const {checkDate} = filterParams
    const [saving, setSaving] = useState(false)
    const [selectedRow, setSelectedRow] = useState()


    const onOpenDialog = (row) => {
        setSelectedRow(row)
    }

    const onClose = () => {
        setSelectedRow(undefined)
    }

    const onSave = async (unitId, disciplineCategories = []) => {
        setSaving(true)
        try {
            const payload = {unitId, checkDate, disciplineCategories}
            await axiosInstance.post(`/api/unit-discipline`, payload)
            setData(current => current.map(
                item => item.unitId === unitId
                    ? {...item, disciplineCategories}
                    : item
            ))
        } catch (e) {
            showErrorNotify("Có lỗi xảy ra. Vui lòng liên hệ quản trị viên!")
        }
        setSaving(false)
        setSelectedRow(undefined)
    }

    useEffect(() => {
        setLoading(true)
        const params = new URLSearchParams(filterParams)
        axiosInstance.get(`/api/unit-discipline?${params.toString()}`)
            .then(rs => setData(rs.data))
            .finally(() => setLoading(false))
    }, [checkDate]);

    return <div style={{marginTop: 16}}>
        {
            !!selectedRow && <UpdateUnitDisciplineDialog open={!!selectedRow} onClose={onClose}
                                                         onSave={onSave}
                                                         saving={saving}
                                                         data={selectedRow}
                                                         checkDate={checkDate}
            />
        }

        {loading && <LinearProgress/>}
        <Table>
            <TableHead>
                <TableRow style={{backgroundColor: "#f5f5f5"}}>
                    <TableCell width={70}>{translate("resources.unit-discipline.fields.unitId")}</TableCell>
                    <TableCell width={150}>{translate("resources.unit-discipline.fields.units")}</TableCell>
                    <TableCell>{translate("resources.unit-discipline.fields.description")}</TableCell>
                    <TableCell width={100}></TableCell>
                </TableRow>
            </TableHead>
        </Table>

        <div style={{overflow: 'auto', height: 600}}>
            <Table>
                <TableBody>
                    {data.map(row => (
                        <TableRow key={row.unitId}>
                            <TableCell width={70}>
                                {row.unitId}
                            </TableCell>
                            <TableCell width={150}>
                                {row.unitName}
                            </TableCell>
                            <TableCell>
                                {
                                    row.disciplineCategories
                                        .filter(item => item.count > 0)
                                        .map(item => `${item.name} (${item.count})`)
                                        .join(' - ')
                                }
                            </TableCell>
                            <TableCell width={100}>
                                <Button size="small" color='primary' onClick={() => onOpenDialog(row)}>
                                    Cập nhật
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    </div>
})

const UnitDisciplineList = (props) => {

    const [filterParams, setFilterParams] = useState({
        checkDate: moment().format('YYYY-MM-DD')
    })

    const onChangeFilter = (field, value) => {
        setFilterParams(params => ({...params, [field]: value}))
    }

    return (<Card>
        <Title title="resources.unit-discipline.name"/>
        <CardContent>
            <Filter {...{filterParams, onChangeFilter}}/>
            <DataTable filterParams={filterParams}/>
        </CardContent>
    </Card>);
};

export default UnitDisciplineList
